export const BINARY_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select a category to continue',
  },
};

export const DEFECT_OPTIONS_ERROR = {
  required: {
    path: 'defect-option-required',
    message: 'Select an option',
  },
};

export const UPLOAD_PHOTO_ERROR = {
  wrong_type: {
    path: 'file-wrong-type',
    message: 'The file must be a JPEG, PNG, GIF or WebP',
  },
  too_large: {
    path: 'file-too-large',
    message: 'The file must be smaller than 30mb',
  },
};

export const ANYTHING_ELSE_ERROR = {
  required: {
    path: 'anythingElseText',
    message:
      'Enter location information such as landmarks or buildings close to the damage.',
  },
  maxLength: {
    path: 'anythingElseText',
    message: `Details on the location must be 500 characters or less.`,
  },
};

export const RECEIVE_EMAIL_ERROR = {
  required: {
    path: 'wantConfirmationEmail',
    message: 'Select if you want to receive a confirmation email.',
  },
};
